import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Loads approved public reviews. Returns { items, total, averageRating, loading }. */
export function useReviews(limit = 50) {
  const [state, setState] = useState({ items: [], total: 0, averageRating: 0, loading: true });

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/reviews`, { params: { limit } })
      .then((res) => {
        if (cancelled) return;
        setState({
          items: res.data.items,
          total: res.data.total,
          averageRating: res.data.average_rating,
          loading: false,
        });
      })
      .catch(() => {
        if (!cancelled) setState((s) => ({ ...s, loading: false }));
      });
    return () => {
      cancelled = true;
    };
  }, [limit]);

  return state;
}
